import { useQuery } from '@apollo/client';
import * as _ from 'lodash-es';
import moment from 'moment';
import React from 'react';
import EmptyState from '../components/EmptyState';
import InfiniteScrollWaypoint from '../components/InfiniteScrollWaypoint';
import Timestamp from '../components/Timestamp';
import { gql } from '../graphql/generated/gql';
import PostRow from '../post/PostRow';
import ConnectionHelper from '../utils/graphql/ConnectionHelper';

const VIEWED_POSTS_QUERY = gql(/** @complexity 18 */ `
  query viewedPosts($afterCursor: String) {
    session: currentSession {
      user {
        id
        viewedPosts(first: 25, after: $afterCursor) {
          edges {
            node {
              id
              updatedAt
              userViewedAt
              ...PostRow_post
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
`);

const useViewedPostsColumn = () => {
  const result = useQuery(VIEWED_POSTS_QUERY);

  const fetchMore = ConnectionHelper.generateFetchMore(
    VIEWED_POSTS_QUERY,
    result,
    'session.user.viewedPosts',
  );
  const { data, loading } = result;
  const posts = _.compact(
    data?.session.user.viewedPosts?.edges?.map((edge) => edge?.node),
  ).toSorted((a, b) => {
    if (a.userViewedAt && b.userViewedAt) {
      return moment(a.userViewedAt).isBefore(b.userViewedAt) ? 1 : -1;
    }
    return 0;
  });

  return {
    seamless: true,
    title: 'Viewed',
    children:
      !loading && posts.length === 0 ? (
        <EmptyState
          imageName="posts"
          title="Haven't read anything yet."
          message="Browse around. There's something interesting in here somewhere."
        />
      ) : (
        <div role="feed" aria-label="Recently viewed posts">
          {posts.map((post) => (
            <PostRow
              key={post.id}
              post={post}
              meta={<Timestamp date={post.updatedAt} />}
            />
          ))}
          <InfiniteScrollWaypoint fetchMore={fetchMore} />
        </div>
      ),
  };
};

export default useViewedPostsColumn;
